export default __webpack_public_path__ + "static/media/logo-deliveroo.5e05dd31.svg";